export default __webpack_public_path__ + "static/media/crown-2.fe8a3acd.webp";